module.exports = __webpack_public_path__ + "static/media/cpg_desktop_instagram_video.766815de.png";